export const BASE_CLASSNAME = 'notification-builder-view'
